// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2oOKC","author":"Table_author__1sXko","authorImage":"Table_authorImage__1sBYB","unreadRow":"Table_unreadRow__8fCKq"};